import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import type { ProjectViewProject } from '@freelancer/datastore/collections';
import { ButtonColor } from '@freelancer/ui/button';
import { Observable } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-project-notes-input',
  template: `
    @if (project$ | flAsync; as project) {
      <fl-textarea
        class="mb-xxsmall"
        flTrackingLabel="DescriptionTextArea"
        [control]="noteControl"
        [maxLength]="maxLength"
        [maxCharacter]="maxCharacter"
      >
      </fl-textarea>
      <div
        [ngClass]="
          maxCharacter
            ? 'ButtonContainer ButtonContainer-characterLimit'
            : 'ButtonContainer'
        "
        class="{{ maxCharacter ? 'mb-none' : 'mb-xsmall' }}"
      >
        <fl-button
          class="mr-xsmall"
          flTrackingLabel="CancelProjectNote"
          i18n="Cancel Project Note"
          [color]="ButtonColor.TEXT_DARK"
          (click)="handleCancel()"
        >
          Clear
        </fl-button>
        <fl-button
          flTrackingLabel="CreateProjectNote"
          i18n="Add Project Note"
          [color]="ButtonColor.SECONDARY"
          (click)="handleAddNote(project.id)"
        >
          Add
        </fl-button>
      </div>
      <fl-hr class="mb-xsmall"></fl-hr>
    }
  `,
  styleUrls: ['./project-notes-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectNotesInputComponent {
  ButtonColor = ButtonColor;

  @Input() maxCharacter?: number;
  @Input() maxLength?: number;
  @Input() noteControl: FormControl<string>;
  @Input() project$: Observable<ProjectViewProject>;
  @Output() onAddNote = new EventEmitter<number>();
  @Output() onCancelNote = new EventEmitter<void>();

  handleAddNote(projectId: number): void {
    this.onAddNote.emit(projectId);
  }

  handleCancel(): void {
    this.onCancelNote.emit();
  }
}
